import * as linkify from "linkifyjs"
export default defineNuxtPlugin((nuxtApp) => {
        // const t = nuxtApp.$i18n.t;

        const validators = {
                file_required: (value) => (value?.length) || 'This field is required',
                required: (value) => !!value || 'This field is required',
                checked: value => !!value || 'This is mandatory',

                password: (value) => {
                    if (value.length < 8) return 'The password must have at least 8 characters'
                    return true;
                },
                password_strong: (value) => {
                        //var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
                        //var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!£@#$%^&*()_\-+=\[\]{};:'",.<>?/\\|`~])[A-Za-z\d!£@#$%^&*()_\-+=\[\]{};:'",.<>?/\\|`~]{8,}$/;
                        var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!£@#$%^&*()_\-+=\[\]{};:'",.<>?\/\\|`~])[A-Za-z\d!£@#$%^&*()_\-+=\[\]{};:'",.<>?\/\\|`~]{8,}$/;


                        if (!regularExpression.test(value)) {
                                return "The password must have minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character";
                        }
                        return true;
                },

                confirm: (password) => value => password === value || `Password does not match`,

                email: (value) => (value && linkify.test(value ?? '', "email") || !value) || 'Use a valid e-mail address',
        }

        nuxtApp.provide("valid", validators)
})
